import { useLazyQuery, useQuery } from "@apollo/client";
import { REPORT } from "../report.queries";
import { ReportQuery, ReportQueryVariables } from "../../../__generated__/ReportQuery";

export const useReport = (id: number) => {
  return useQuery<ReportQuery, ReportQueryVariables>(REPORT, { variables: { id } });
};

export const useLazyReport = () => {
  return useLazyQuery<ReportQuery, ReportQueryVariables>(REPORT);
};
